<template>
  <div
    class="modal black"
    id="filterModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-md"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"></h5>
          <div class="action">
            <!-- <a href="#" class="mx-3"><i class="fa fa-expand"></i></a> -->
            <a @click="$emit('close')" aria-label="Close"
              ><i class="fa fa-times "></i
            ></a>
          </div>
        </div>

        <div class="modal-body">

          <div class="row mb-4 align-items-end" >
            <div class="col d-flex flex-column" v-if="bid.bidType === 'BID'">
              <label class="form-label">Bid Price</label>
               <currency-input
                        v-model="updatedBidPrice"
                        currency="USD"
                        class="form-control w-100"
                      />
            </div>
             <div class="col d-flex flex-column">
              <label class="form-label">Bid Quantity</label>
              <input``
                type="number"
                v-model="updateBidQty"
                class="form-control w-100">

            </div>
          </div>
          <!-- THIS DIV WAS MISSING -->
          <div class="mt-5 mb-2">
            <button
              class="btn btn-secondary"
              @click="$emit('close')"
            >
             CLOSE
            </button>
            <button
              :disabled="!updatedBidPrice || !updateBidQty"
              class="btn btn-success"
              @click="updateBidPrice()"
            >
              UPDATE 
            </button>
          </div>
        </div>
        <!-- closes modal-body -->
      </div>
      <!-- closes modal-content -->
    </div>
    <!-- closes modal-dialog -->
  </div>
  <!-- closes modal -->
</template>

<script>
// import Datepicker from 'vuejs-datepicker'
import config from '@/config'
import authService from '@/authService'

export default {
  name: 'UpdateBidPrice',
  components: {
    // Datepicker
  },
  props: {
    bid: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      updatedBidPrice: '',
      updateBidQty: '',
    }
  },
  methods: {

     updateBidPrice() {
      console.log('updateBidPrice', this.updatedBidPrice, this.bid.minQuantity, this.updateBidQty)
      if(this.bid.minQuantity && this.updateBidQty < this.bid.minQuantity) {
        this.$alert(`Minimum quantity for this offering is ${this.bid.minQuantity}. Please adjust your quantity.`, '', 'error')
        return;
      }
      if(this.bid.offerQuantity && this.updateBidQty > this.bid.offerQuantity) {
        this.$alert(`Maximum quantity for this offering is ${this.bid.offerQuantity}. Please adjust your quantity.`, '', 'error')
        return;
      }
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      this.$http
        .put(
          config.baseUrlAutoBidder + "/offering-feed/client-bid",
          {
            userId: authService.getUser().id,
            bidId: this.bid.id,
            price: this.updatedBidPrice,
            clientName:"drl",
            quantity: this.updateBidQty
          },
          auth
        )
        .then(() => {
            this.$alert(
            `Updated successfully.`,
            '',
            'success'
          )
          this.$emit('close')
        })
    },
   
  },
  mounted () {
    this.updatedBidPrice = this.bid.price
    this.updateBidQty = this.bid.quantity
  }
}
</script>
<style scoped>


</style>
